import styled from 'styled-components'

export const ItemPanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-top: 10px;

  @media (min-width: 1200px) {
    gap: 30px;
  }

  .filters {
    display: flex;
    gap: 15px;
  }

  .MuiSnackbar-root {
    position: absolute;
    max-width: 600px;

    @media (min-width: 1200px) {
      position: fixed;
      left: unset;
      bottom: 75px;
      width: min-content;
    }

    .MuiSnackbarContent-root {
      background-color: #c1dfc4;
      color: #1d1d1b;
      border-radius: 0;
      font-size: 16px;

      .MuiSnackbarContent-action {
        button {
          border: none;
          background-color: inherit;
          font-weight: 600;
          text-decoration: underline;
          padding: 0 15px 8px;
        }
      }
    }
  }
`

export const ModalItemInfo = styled.div`
  max-width: 550px;
  padding-bottom: 15px;

  img {
    width: 100%;
    max-width: 500px;
    margin-bottom: 15px;

    @media (min-width: 1200px) {
      width: 50%;
      float: left;
      margin-bottom: 30px;
    }
  }

  h2 {
    font-size: 24px;

    @media (min-width: 1200px) {
      padding-top: 30px;
    }
  }

  h3 {
    margin: 15px 0px 20px;
  }

  table {
    margin-top: 30px;

    @media (min-width: 1200px) {
      clear: left;
    }

    tr {
      display: table-row;
      vertical-align: top;

      &:nth-child(2n) {
        background-color: ${(props) => props.theme.palette.background.main};
      }

      td {
        padding: 5px;
        width: 50%;
        font-size: 14px;

        &:first-child {
          font-weight: 500;
        }
      }
    }
  }
`
